/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { EuiFlexGroup, EuiFlexItem } from '../flex';
import { EuiIcon } from '../icon';

var resolveIconAndColor = function resolveIconAndColor(checked) {
  if (!checked) {
    return {
      icon: 'empty'
    };
  }

  return checked === 'on' ? {
    icon: 'check',
    color: 'text'
  } : {
    icon: 'cross',
    color: 'text'
  };
};

export class EuiFilterSelectItem extends Component {
  static defaultProps = {
    showIcons: true
  };
  buttonRef = null;
  state = {
    hasFocus: false
  };
  focus = () => {
    if (this.buttonRef) {
      this.buttonRef.focus();
    }
  };
  hasFocus = () => {
    return this.state.hasFocus;
  };

  render() {
    const {
      children,
      className,
      disabled,
      checked,
      isFocused,
      showIcons,
      ...rest
    } = this.props;
    const classes = classNames('euiFilterSelectItem', {
      'euiFilterSelectItem-isFocused': isFocused
    }, className);
    let iconNode;

    if (showIcons) {
      const {
        icon,
        color
      } = resolveIconAndColor(checked);
      iconNode = <EuiFlexItem grow={false}>
          <EuiIcon color={color} type={icon} />
        </EuiFlexItem>;
    }

    return <button ref={ref => this.buttonRef = ref} role="option" type="button" aria-selected={isFocused} className={classes} disabled={disabled} aria-disabled={disabled} {...rest}>
        <EuiFlexGroup alignItems="center" gutterSize="s" component="span" responsive={false}>
          {iconNode}
          <EuiFlexItem className="euiFilterSelectItem__content" component="span">
            {children}
          </EuiFlexItem>
        </EuiFlexGroup>
      </button>;
  }

}
EuiFilterSelectItem.propTypes = {
  checked: PropTypes.oneOf(["on", "off"]),
  showIcons: PropTypes.bool,
  isFocused: PropTypes.bool,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};

try {
  EuiFilterSelectItem.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/filter_group/filter_select_item.tsx',
    description: '',
    displayName: 'EuiFilterSelectItem',
    methods: [],
    props: {
      checked: {
        defaultValue: null,
        description: '',
        name: 'checked',
        parent: {
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        },
        declarations: [{
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'FilterChecked',
          value: [{
            value: '"on"'
          }, {
            value: '"off"'
          }]
        }
      },
      showIcons: {
        defaultValue: {
          value: 'true'
        },
        description: '',
        name: 'showIcons',
        parent: {
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        },
        declarations: [{
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      isFocused: {
        defaultValue: null,
        description: '',
        name: 'isFocused',
        parent: {
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        },
        declarations: [{
          fileName: 'app/src/components/filter_group/filter_select_item.tsx',
          name: 'EuiFilterSelectItemProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['EuiFilterSelectItemProps', 'CommonProps', 'ButtonHTMLAttributes', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes']
  };
} catch (e) {}